import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Title = styled.div`
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#1010EB')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
    ${media.mobileDevice`
    `}
`;
export const Subtitle = styled.div`
    display: ${({ display }) => display && display};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    width: ${({ width }) => (width ? width : '100%')};
    line-height: ${({ lineHeight }) => lineHeight};
    cursor: ${({ cursor }) => (cursor ? cursor : ' ')};
    ${media.mobileDevice`
        width:${({ mbWidth }) => (mbWidth ? mbWidth : '90%')};
    `};
`;
